module.exports = __webpack_public_path__ + "img/10.4de3995b.svg";